export enum DestinationModalNames {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
}

export interface DestinationChildrenModel {
  type?: string;
  name: DestinationModalNames;
}

export const DestinationModalChildrenData: DestinationChildrenModel[] = [
  { name: DestinationModalNames.CREATE },
  { name: DestinationModalNames.UPDATE },
];
